import { useState, useEffect } from 'react';
import { Heart, Loader } from 'lucide-react';
import { getLanguage } from '../../../utils/Helper';
import { useWishlist } from '../../../context/WishlistContext';
import './WishlistButton.scss';

const WishlistButton = ({ productVariantId, className = '' }) => {
  const [loading, setLoading] = useState(false);
  const [currentLanguage] = useState(getLanguage());
  
  const { isInWishlist, addToWishlist, removeFromWishlist, wishlistItems } = useWishlist();

  const isInWishlistState = isInWishlist(productVariantId);

  const handleToggleWishlist = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (loading) return;

    setLoading(true);

    try {
      if (isInWishlistState) {
        // Find the wishlist item
        const item = wishlistItems.find(i => 
          i.product.variants && 
          i.product.variants.some(variant => variant.id === productVariantId)
        );
        
        if (item) {
          await removeFromWishlist(item.id);
        }
      } else {
        // Add to wishlist
        await addToWishlist(productVariantId);
      }
    } catch (error) {
      console.error('Error toggling wishlist:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className={`wishlist-button ${isInWishlistState ? 'active' : ''} ${className}`}
      onClick={handleToggleWishlist}
      disabled={loading}
      title={isInWishlistState 
        ? (currentLanguage === 'EN' ? 'Remove from wishlist' : 'إزالة من المفضلة')
        : (currentLanguage === 'EN' ? 'Add to wishlist' : 'إضافة للأمنيات')
      }
    >
      {loading ? (
        <Loader size={20} className="spinner" />
      ) : (
        <Heart 
          size={20} 
          fill={isInWishlistState ? '#ff4757' : 'none'}
          className="heart-icon"
        />
      )}
    </button>
  );
};

export default WishlistButton;